import Order from '../models/Order';
import {OrderPool} from '../models/OrderPool';

export const checkIfOrderPool = (
	value: Order | OrderPool
): value is OrderPool => {
	return (
		(value as OrderPool)?.dndCompany != undefined &&
		(value as OrderPool)?.orders != undefined
	);
};

export const checkIfOrder = (value: Order | OrderPool): value is Order => {
	return (value as Order)?.orderedArticles != undefined;
};
